<template lang="">
  <nav class="d-flex flex-row text-light p-0">
    <router-link to="/maps" class="d-flex justify-content-center flex-column">
      <img src="@/assets/img/maps.svg" />
      <p class="nav-text">Mapa</p>
    </router-link>
    <router-link
      to="/devices"
      class="d-flex justify-content-center flex-column"
    >
      <img src="@/assets/img/devices.svg" />
      <p class="nav-text">Unidades</p>
    </router-link>
    <router-link
      to="/reports"
      class="d-flex justify-content-center flex-column"
    >
      <img src="@/assets/img/reports.svg" />
      <p class="nav-text">Reportes</p>
    </router-link>
    <router-link to="/alerts" class="d-flex justify-content-center flex-column" id="p-alerts">
      <img src="@/assets/img/alerts.svg" />
      <p class="nav-text">Alertas</p>
    </router-link>
  </nav>
</template>

<script lang="ts">
export default {}
</script>

<style lang="sass" scoped>
@import '@/assets/style/variables.sass'
nav
  height: 65px
  a
    width: 25%
    height: 100%
    color: #fff
    text-decoration: none
    background: $primary
    text-align: center
    vertical-align: center
    img
      height: 45%
    p
      margin: 0px !important
  .router-link-exact-active
    background: $secondary
</style>
